import { render, staticRenderFns } from "./conferences.vue?vue&type=template&id=05690f6d&scoped=true"
import script from "./conferences.vue?vue&type=script&lang=js"
export * from "./conferences.vue?vue&type=script&lang=js"
import style0 from "./conferences.vue?vue&type=style&index=0&id=05690f6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05690f6d",
  null
  
)

export default component.exports